import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { isNil } from "@grandvisionhq/utils";
import { RemoveVoucherCode } from "./RemoveVoucherCode.js";
import { REMOVE_CART_VOUCHER_CODES } from "../../../../../../operations/mutations/operations/mutations/remove-cart-voucher-codes.js";
import { GET_CART } from "../../../../../../operations/queries/operations/queries/get-cart.js";
const RemoveVoucherCodeContainer = ({ voucherCode, ...rest }) => {
  const [{ cartId }] = useCartStorage();
  const [removeCartVoucherCodes] = useMutation(REMOVE_CART_VOUCHER_CODES);
  const handleRemove = React.useCallback(() => {
    if (!cartId || !voucherCode) {
      return;
    }
    removeCartVoucherCodes({
      variables: {
        cartInput: {
          cartId,
          voucherCodes: [voucherCode]
        }
      },
      update(cache, { data }) {
        if (data && data.removeCartVoucherCodes.success === true) {
          const newCart = data.removeCartVoucherCodes.cart;
          cache.writeQuery({
            query: GET_CART,
            variables: { id: cartId },
            data: { cart: { cart: newCart, validationErrors: null, failures: null } }
          });
        }
      }
    });
  }, [cartId, removeCartVoucherCodes, voucherCode]);
  if (isNil(cartId) || !voucherCode) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(RemoveVoucherCode, { onRemove: handleRemove, voucherCode, ...rest });
};
export {
  RemoveVoucherCodeContainer
};
//# sourceMappingURL=RemoveVoucherCodeContainer.js.map
